import { render } from "./AccountSearchResults.vue?vue&type=template&id=555b56ca"
import script from "./AccountSearchResults.vue?vue&type=script&lang=js"
export * from "./AccountSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__